module.exports = __webpack_public_path__ + "img/bus-station-blue.cdd80474.svg";